import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Features } from "./components/Features";
import { HowItWorks } from "./components/HowItWorks";
import { Incentives } from "./components/Incentives";
import { Screenshots } from "./components/Screenshots";
import { CTA } from "./components/CTA";
import { DemoCTA } from "./components/DemoCTA";
import { FAQ } from "./components/FAQ";
import { Footer } from "./components/Footer";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsOfService } from "./pages/TermsOfService";
import { USTPage } from "./pages/UST";
import { OfficialRules } from "./pages/OfficialRules";
import AuthActionPage from "./pages/AuthActionPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import DeleteAccountPage from "./pages/DeleteAccountPage";

function LandingPage() {
  return (
    <div className="min-h-screen bg-bg-deep">
      <Navbar />
      <Hero />
      <Features />
      <HowItWorks />
      <Incentives />
      <Screenshots />
      <DemoCTA />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/ust" element={<USTPage />} />
        <Route path="/ust/official-rules" element={<OfficialRules />} />
        <Route path="/auth/action" element={<AuthActionPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/delete-account" element={<DeleteAccountPage />} />
      </Routes>
    </BrowserRouter>
  );
}
